import { useEffect, useState } from "react";

export function DvdLogoAnimation() {
  const width = 40;
  const height = 12;
  const logo = "DVD";
  const [pos, setPos] = useState({ x: 0, y: 0, dx: 1, dy: 1 });

  useEffect(() => {
    const id = setInterval(() => {
      setPos(({ x, y, dx, dy }) => {
        let nx = x + dx;
        let ny = y + dy;
        let ndx = dx;
        let ndy = dy;
        if (nx < 0 || nx > width - logo.length) {
          ndx = -dx;
          nx = x + ndx;
        }
        if (ny < 0 || ny > height - 1) {
          ndy = -dy;
          ny = y + ndy;
        }
        return { x: nx, y: ny, dx: ndx, dy: ndy };
      });
    }, 120);
    return () => clearInterval(id);
  }, []);

  const lines: string[] = [];
  for (let r = 0; r < height; r++) {
    let line = " ".repeat(width);
    if (r === pos.y) {
      line =
        line.substring(0, pos.x) + logo + line.substring(pos.x + logo.length);
    }
    lines.push(line);
  }

  return (
    <pre style={{ height: height * 12, lineHeight: "12px" }}>
      <code>{lines.join("\n")}</code>
    </pre>
  );
}
